import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserLevelList } from '../../api/userLevel';
import { message } from 'antd';

// 获取用户等级列表
export const fetchUserLevels = createAsyncThunk(
  'userLevel/fetchUserLevels',
  async (params, { rejectWithValue }) => {
    try {
      const response = await getUserLevelList(params);
      return response.data;
    } catch (error) {
      message.error('获取用户等级列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  userLevelList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    searchParams: {
      userId: undefined,
      username: undefined,
      nickname: undefined,
      currentLevel: undefined,
      minExp: undefined,
      maxExp: undefined,
      minTaskCount: undefined,
      maxTaskCount: undefined,
      startTime: undefined,
      endTime: undefined
    }
  }
};

const userLevelSlice = createSlice({
  name: 'userLevel',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.userLevelList.searchParams = {
        ...state.userLevelList.searchParams,
        ...action.payload
      };
      
      // 如果传入了页码或每页条数，更新对应的值
      if (action.payload.page) {
        state.userLevelList.current = action.payload.page;
      }
      
      if (action.payload.size) {
        state.userLevelList.size = action.payload.size;
      }
    },
    resetSearchParams: (state) => {
      state.userLevelList.searchParams = {
        userId: undefined,
        username: undefined,
        nickname: undefined,
        currentLevel: undefined,
        minExp: undefined,
        maxExp: undefined,
        minTaskCount: undefined,
        maxTaskCount: undefined,
        startTime: undefined,
        endTime: undefined
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserLevels.pending, (state) => {
        state.userLevelList.loading = true;
      })
      .addCase(fetchUserLevels.fulfilled, (state, action) => {
        state.userLevelList.loading = false;
        state.userLevelList.data = action.payload.records;
        state.userLevelList.total = action.payload.total;
        state.userLevelList.current = action.payload.current;
        state.userLevelList.size = action.payload.size;
      })
      .addCase(fetchUserLevels.rejected, (state) => {
        state.userLevelList.loading = false;
      });
  }
});

export const { setSearchParams, resetSearchParams } = userLevelSlice.actions;
export default userLevelSlice.reducer; 